<script lang="ts" setup>
import type { ToasterProps } from 'vue-sonner';

import Icon from '@/components/primitives/Icon.vue';
import { cn } from '@/lib/utils';
import { Toaster as Sonner } from 'vue-sonner';

const props = defineProps<ToasterProps>()
</script>

<template>
  <Sonner
    :class="cn('toaster group', props.class)"
    :style="{
      '--normal-bg': 'var(--popover)',
      '--normal-text': 'var(--popover-foreground)',
      '--normal-border': 'var(--border)',
      '--success-bg': 'var(--success)',
      '--success-text': 'var(--success-foreground)',
      '--success-border': 'var(--success)',
      '--error-bg': 'var(--destructive)',
      '--error-text': 'var(--destructive-foreground)',
      '--error-border': 'var(--destructive)',
      '--warning-bg': 'var(--warning)',
      '--warning-text': 'var(--warning-foreground)',
      '--warning-border': 'var(--warning)',
      '--info-bg': 'var(--info)',
      '--info-text': 'var(--info-foreground)',
      '--info-border': 'var(--info)',
      '--border-radius': 'var(--radius-box)',
    }"
    v-bind="{
      ...props,
      class: undefined,
      toastOptions: {
        ...props.toastOptions,
        classes: {
          ...props.toastOptions?.classes,
        },
      },
    }"
  >
    <template #success-icon>
      <Icon name="circle-check" class="size-4" />
    </template>
    <template #info-icon>
      <Icon name="info" class="size-4" />
    </template>
    <template #warning-icon>
      <Icon name="alert-triangle" class="size-4" />
    </template>
    <template #error-icon>
      <Icon name="octagon-x" class="size-4" />
    </template>
    <template #loading-icon>
      <div>
        <Icon name="loader2" class="size-4 animate-spin" />
      </div>
    </template>
    <template #close-icon>
      <Icon name="close" class="size-4" />
    </template>
  </Sonner>
</template>
